import { api } from '../services/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const fetchAboutContent = createAsyncThunk('about/fetchAboutContent', async (_, { rejectWithValue }) => {
    try {
        const response = await api.get('/about');
        const data = response.data;
        let aboutContent = Array.isArray(data) ? data[0] : data;

        // Parse characteristics if it's a string
        if (aboutContent && typeof aboutContent.characteristics === 'string') {
            try {
                aboutContent.characteristics = JSON.parse(aboutContent.characteristics);
            } catch (e) {
                aboutContent.characteristics = [];
            }
        }

        return aboutContent;
    } catch (error) {
        return rejectWithValue(error?.message || 'Failed to fetch about content');
    }
}
);

const aboutSlice = createSlice({
    name: 'about',
    initialState: {
        data: null,
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAboutContent.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchAboutContent.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchAboutContent.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || action.error.message;
            });
    },
});

export const selectAboutData = (state) => state.about.data;
export const selectAboutStatus = (state) => state.about.status;
export const selectAboutError = (state) => state.about.error;

export default aboutSlice.reducer;
